import { useSelector } from 'react-redux';

import { EditorAccessTier } from 'dashboard/apps/InquiryTemplateEditor/hooks/useIsEditableWithOptions';
import { Feature } from 'dashboard/models/inquiry-template-version';
import { Organization } from 'dashboard/models/organization';
import { User } from 'dashboard/models/user';
import { RootState } from 'dashboard/redux/store';
import { SegmentClient } from 'lib/clients/SegmentClient';

const SegmentEvents: Record<Exclude<EditorAccessTier, EditorAccessTier.Any>, string> = {
  [EditorAccessTier.InquiriesBasic]: 'Inquiries Basic - Learn more clicked',
  [EditorAccessTier.InquiriesFree]: 'Inquiries Free - Learn more clicked',
  [EditorAccessTier.InquiriesEnhanced]: 'Inquiries Enhanced - Learn more clicked',
};

const SALES_CONTACT_US_LINK = '/dashboard/contact-us?category=sales';

// TODO(Collection-Editor) Consider merging this with useOnEnhancedLearnMoreClick which has similar behavior
export default ({ id }: { id: string }) => {
  const { currentUser, organization } = useSelector<
    RootState,
    { currentUser: User; organization: Organization }
  >((state) => {
    return {
      currentUser: state.currentUser?.currentUser,
      organization: state.organization?.organization,
    };
  });

  const linkElementId = `learn-more-link__${id}`;

  return {
    linkElementId,
    onLearnMoreClick: ({
      feature,
      accessTier,
    }: {
      feature?: Feature | null;
      accessTier: Exclude<EditorAccessTier, EditorAccessTier.Any>;
    }) => {
      const segmentEvent = feature
        ? SegmentEvents[EditorAccessTier.InquiriesEnhanced]
        : SegmentEvents[accessTier];

      SegmentClient.sendSegmentTrackEvent(segmentEvent, {
        feature,
        product: 'Inquiries',
        userId: currentUser?.id,
        organizationId: organization?.id,
        clicked_element: linkElementId,
      });

      window.open(SALES_CONTACT_US_LINK, '_blank');
    },
  };
};
